import { navigateTo, useRoute, useRouteParams } from '#imports'
import { type MaybeRefOrGetter, toValue } from 'vue'

import type { ArticlePageContent } from '@backmarket/http-api/src/api-specs-content'

export function useHandleIncorrectRouteParams(
  contentRef: MaybeRefOrGetter<ArticlePageContent | null>,
) {
  const content = toValue(contentRef)

  if (!content || content.categories.length < 1) {
    return
  }

  const articleCategories = content.categories
  const { slug: referenceCategory } =
    articleCategories[articleCategories.length - 1]

  const { category: routeCategory, pageName } = useRouteParams()

  const isValidCategory =
    !!referenceCategory &&
    !!routeCategory &&
    referenceCategory === routeCategory

  if (!isValidCategory) {
    void navigateTo(
      {
        ...useRoute(),
        params: {
          pageName,
          category: referenceCategory,
        },
      },
      { redirectCode: 301 },
    )
  }
}
